export class GoogleWorkspaceWithPolicyStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerId",
            "baseName": "providerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "attachedToPolicy",
            "baseName": "attachedToPolicy",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceWithPolicyStatus.attributeTypeMap;
    }
    constructor() {
    }
}
